/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_BundeslandInputs */

const en__field_bundesland = /** @type {(inputs: _Field_BundeslandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundesland`)
};

const de__field_bundesland = /** @type {(inputs: _Field_BundeslandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundesland`)
};

/**
* | output |
* | --- |
* | "Bundesland" |
*
* @param {_Field_BundeslandInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_bundesland = /** @type {((inputs?: _Field_BundeslandInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_BundeslandInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_bundesland(inputs)
	return de__field_bundesland(inputs)
});